<template>
  <div
    class="ll-state-with-action"
    :style="{marginTop:marginTop+'px'}"
  >
    <LlState
      v-for="(state,stateIndex) in C_stateList"
      :key="stateIndex"
      v-model="C_stateList[stateIndex].value"
      :is-required="state.required"
      :type="state.type"
      :placeholder="state.placeholder"
      :title="state.title"
      :rules="state.rules"
      :leading-icon="state.leadingIcon"
      :has-check-box="state.hasCheckBox"
      :is-check-box-select="state.isCheckBoxSelect"
      :checkbox-text="state.checkboxText"
      @checkbox-select="$_checkBoxSelect($event,state)"
    />
    <WsButton001
      width-stretch
      :isloading="isloading"
      @click="onClick()"
    >
      {{ btnText }}
    </WsButton001>
  </div>
</template>
<script>
export default {
  name: "LlStateWithAction",
  props: {
    isloading: {
      type: Boolean,
      default: false,
    },
    stateList: {
      type: Array,
      default() {
        return [];
      },
    },
    btnText: {
      type: String,
      default: "",
    },
    marginTop: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    C_stateList: [],
  }),
  watch: {
    stateList: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.C_stateList = newValue;
      },
    },
  },
  methods: {
    onClick() {
      this.$emit("submit", this.C_stateList);
    },
    $_checkBoxSelect($event, state) {
      state.isCheckBoxSelect = $event;
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-state-with-action";
</style>